// Idea taken from https://redux.js.org/recipes/structuring-reducers/refactoring-reducers-example#combining-reducers-by-slice
// Basically each entity (company, part etc.) is structured to under one reducer. So when there will be more reducers, those
// just will be added to initialState and slide reducer.

import {LOAD_PARTS_REQUEST, LOAD_PARTS_SUCCESS, LOAD_PARTS_FAILURE, ADD_PART_REQUEST, PARTS_EDIT_PART, PARTS_DELETE_PART, DELETE_PARTS_REQUEST } from '../actions/actionTypes';
import {createReducer, updateObject} from './reducerUtilities';

const initialState = {
  parts: {
      partsData: null,
      isLoading: false,
      hasFailed: false,
      isDeleting: false,
      deleteHasFailed: false
  },
};


// Slice reducer
export const partReducer = createReducer(initialState, {
  [LOAD_PARTS_REQUEST] : loadPartsRequest,
  [LOAD_PARTS_SUCCESS] : loadPartsSuccess,
  [LOAD_PARTS_FAILURE] : loadPartsFailure,
  [ADD_PART_REQUEST] : addPartRequest,
  [PARTS_EDIT_PART] : editPart,
  [DELETE_PARTS_REQUEST] : deletePartsRequest,   
  [PARTS_DELETE_PART] : deletePart
});



// -----------------------------------------------------------------------
// LOAD COMPANIES
// -----------------------------------------------------------------------


// Case reducer
function loadPartsRequest(state, action) {
  return {...state, parts: updateObject(
      state.parts, { 
          isLoading: true 
      })};
}

// Case reducer
function loadPartsSuccess(state, action) {   
  return {...state, parts: updateObject(
      state.parts, { 
          partsData: action.payload.parts, 
          isLoading: false 
      })};
}

// Case reducer
function loadPartsFailure(state, action) {
  return {...state, parts: updateObject(
      state.parts, { 
          partsData: [], 
          isLoading: false, 
          hasFailed: true 
      })};
}


function addPartRequest(state, action) {
  return {...state, parts: updateObject(
      state.parts, { 
          partsData: [...state.parts.partsData, action.data]
      })};    
}

function editPart(state, action) {
  return {...state, parts: updateObject(
      state.parts, { 
          partsData: state.parts.partsData.map(c => c.id === action.data.id ? action.data : c)
      })}; 
}

// Case reducer
function deletePartsRequest(state, action) {
  return {...state, parts: updateObject(
      state.parts, { 
          isDeleting: action.data,
      })};
}

function deletePart(state, action) {
  let newParts = state.parts.partsData;
  const indx = newParts.findIndex(t => t.id === action.data);
  if(indx > -1) {
      newParts.splice(indx, 1);
  }
  return {...state, parts: updateObject(
      state.parts, {
          partsData: newParts
      }
  )}
}

// -----------------------------------------------------------------------
// TODO
// -----------------------------------------------------------------------



// WEBPACK FOOTER //
// ./src/reducers/partReducer.js